// extracted by mini-css-extract-plugin
module.exports = {"cuadroActualizacion":"ultimaActualizacion_cuadroActualizacion__a8GOI","hora":"ultimaActualizacion_hora__3QQ-i","ButtonActua":"ultimaActualizacion_ButtonActua__3_Seg"};